import React from 'react';
import NewArticlePriceButtonProperties from "./NewArticlePriceButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import NewArticlePriceStore from "./NewArticlePriceStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./NewArticlePriceButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import clsx from 'clsx';
import PriceInput from '../../Inputs/PriceInput/PricetInput';
import DeliveryTimeInput from '../../Inputs/DeliveryTimeInput/DeliveryTimeInput';
import { useUserContext } from '../../../contexts/UserContext';
import DeliveryTimeSelect from '../../Selects/DeliveryTimeSelect/DeliveryTimeSelect';


const NewArticlePriceButton: React.FC<NewArticlePriceButtonProperties> = ({
                                                                                onClick = () => {
                                                                                },
                                                                                onSave = () => {
                                                                                },
                                                                                showIcon = true,
                                                                                showText = true,
                                                                                disabled,
                                                                                className = '',
                                                                                articleId,
                                                                                articlePriceId,
                                                                                rounded = false,
                                                                                size = ButtonSize.DEFAULT,
                                                                                type = ButtonType.DEFAULT,
                                                                                customButton = null,
                                                                                agencyId
                                                                            }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    
    const [store] = React.useState(
        () => new NewArticlePriceStore(commonContext, articleId, articlePriceId, agencyId)
    );

    const isRootAgency = userStore.isRootAgency();

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    // const onGeoChange = (newGeo: Geo | undefined) => {
    //     store.articlePrice.geo = newGeo;
    //     store.articlePrice.geoId = newGeo ? newGeo.id : '';
    // }
    const onAmountChange = (newAmount: number) => store.articlePrice.price = newAmount;
    const onDeliveryTimeChange = (newDeliveryTime?: number) => store.articlePrice.deliveryTimeDays = newDeliveryTime;

    const onArticlePriceSave = async () => {
        const saved = await store.save();
        if (saved) {
            if (onSave) {
                onSave(store.articlePrice);
            }
            store.closeModal();
        }
    }

    const text = i18n.translate((store.isEditing ? "EDIT_ARTICLE_PRICE" : "NEW_ARTICLE_PRICE"));
    const btnIcon = store.isEditing ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;
    const Btn = () => {
        if (customButton != null) {
            return <div className={classes.custom_button_container} onClick={handleOnclick}>{customButton}</div>;
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal}
                       open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        {/* <GeoSelect selected={store.articlePrice.geo} onChange={onGeoChange} className={clsx(classes.input)}/> */}
                        <PriceInput value={store.articlePrice.price} error={i18n.translate(store.amountError)} fullWidth className={clsx(classes.input)}
                            onChange={onAmountChange}/>
                        {isRootAgency && <DeliveryTimeInput value={store.articlePrice.deliveryTimeDays} error={i18n.translate(store.deliveryTimeError)} fullWidth className={clsx(classes.input)}
                            onChange={onDeliveryTimeChange}/>}
                        {!isRootAgency && <DeliveryTimeSelect selected={store.articlePrice.deliveryTimeDays} articleId={store.articleId} fullWidth className={clsx(classes.input)}
                            onChange={onDeliveryTimeChange}/>}
                        <div className={classes.btn_container}>
                            <Button
                                disabled={!store.enableButton}
                                loading={store.loading} className={classes.input} onClick={onArticlePriceSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                            <Button
                                loading={store.loading} className={classes.cancel_btn} onClick={onCloseModal}
                                type={ButtonType.DEFAULT}
                                text={i18n.translate("CANCEL")}/>
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewArticlePriceButton;
